import { render, staticRenderFns } from "./ModalConfig.vue?vue&type=template&id=1dc359f2&scoped=true&"
import script from "./ModalConfig.vue?vue&type=script&lang=js&"
export * from "./ModalConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfig.vue?vue&type=style&index=0&id=1dc359f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc359f2",
  null
  
)

export default component.exports